export default __webpack_public_path__ + "static/media/white_logo.0612fcf1.svg";